import { apiClient, ApiResult } from '@/lib/api-client';
import { OrganizationFormData } from '../entities/Organization';

export const lookupCompanyByWebsite = async (url: string): Promise<OrganizationFormData | null> => {
  const { data } = await apiClient.post<ApiResult<OrganizationFormData>>('/scrape', {
    url
  });
  if (data.isSuccess !== true) {
    return null;
  }
  return data.value;
};
